import { t } from 'i18next';
import { useState } from 'react';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import { NotificationTypes } from '../../../../../components/Notification/notificationEnums';
import HttpStatus from '../../../../../enums/httpStatus';
import { convertBudgetToOrderApi } from '../../../../../services/requests/orders/convertBudgetToOrder';
import { Order } from '../../../../../types/apiResponse/order';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  callback: () => void;
  order: Order;
};

const BudgeToOrderModal = ({ showModal, closeModal, callback, order }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const updateBudgetOrder = async () => {
    if (order.history_only || !order.NumeroPedido) return;
    try {
      setIsLoading(true);

      const response = await convertBudgetToOrderApi(order.NumeroPedido);
      if (response.status === HttpStatus.OK) {
        frontendNotification({
          message: t('success'),
          type: NotificationTypes.SUCCESS,
        });
        callback();
        closeModal();
      } else {
        throw response;
      }
    } catch (erro) {
      backendErrorNotification(erro as any);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={`${t('budget')}: ${order.NumeroPedido}`}
      showModal={showModal}
      action={() => updateBudgetOrder()}
      actionNameBtn={t('confirm')}
      cancelButton={closeModal}
      closeModal={closeModal}
      bodyStyle={{ overflow: 'scroll', width: '100%' }}
      isLoading={isLoading}
    >
      <div style={{ padding: '1rem' }}>
        <p style={{ margin: 0 }}>{t('convertBudgetToOrder') as string}?</p>
      </div>
    </Modal>
  );
};

export default BudgeToOrderModal;
